<template>
  <div class="login_body">
    <!--    <img class="login_header_img" src="@/assets/login/banner_bgi.png" alt="" />-->

    <!--    <div class="login_header_img_bgi"></div>-->
    <template v-if="step == 0">

      <div class="productBox">
        <img src="@/assets/icon/logo.png" alt=""/>
        <!-- <div class="productBox_hello">{{ l.home_login_hello }}</div>
        <div class="productBox_welcome">{{ l.home_login_welcome }}准借</div> -->
        <div class="productBox_product">准借</div>
      </div>
      <div class="form_input_box">
        <Form
            ref="form"
            @submit="sendCode"
            @failed="onFailed"
            :show-error-message="true"
        >
          <div class="field_label">{{ l.other_phone }}</div>
          <Field
              class="field-input"
              v-model="phone"
              name="phone"
              type="tel"
              :placeholder="l.login_p_phone"
              maxlength="10"
              :rules="[
          { required: true, message: '' }, // l.login_p_phone
          {
            validator: checkPhone,
            message: `${
              ![null, undefined].includes(phone) ? l.login_p_phone_toast : ''
            }`,
          }, // l.login_p_phone_toast
        ]"
          >
          </Field>
          <div id="captcha"></div>
          <!-- <div class="field_label">{{ l.login_l_code }}</div> -->
          <!-- <div class="newUser">*{{ l.login_submit_msg }}</div> -->
          <div style="margin-top: 40px">
            <Button
                size="normal"
                class="loginSubmit"
                :class="isOver && 'loginOver'"
                type="info"
                block
                native-type="submit"
            >{{ l.login_get_code }}
            </Button
            >
          </div>
        </Form>
      </div>
      <div class="form_box">
        <div class="commit_checkbox">
        <span class="read">*{{ l.home_login_privacy_policy }}</span
        ><span class="privacy" @click.stop="showAuditBox(0)">{{
            l.home_toast_fail_btn
          }}</span>
        </div>
      </div>
    </template>
    <template v-if="step == 1">
      <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
        <Icon class="navbar_icon" name="arrow-left" @click="step = 0"/>
        <span>{{ l.login_l_code }}</span>
        <div class="icon_box"></div>
      </div>

      <div class="code_text">
        <div class="code_text_title">{{ l.login_code }}</div>
        <div class="code_text_desc" v-html="codeDesc"></div>
      </div>

      <div class="CodeInput_box">
        <CodeInput @inputComplete="inputComplete"></CodeInput>
      </div>
      <div class="code_time_box">
        <div class="code_time">
          (<span>{{ time }}s</span>){{ l.login_again_send_code }}
        </div>
      </div>
      <div class="code_again_box">
        <Button
            :disabled="time!=0"
            size="normal"
            class="loginSubmit"
            :class="time === 0 && 'loginOver'"
            type="info"
            block
            @click="sendCode"
        >{{ l.login_again_send }}
        </Button>
      </div>

    </template>
    <AuditBox
        :boxIndex="textIndex"
        :show="isShowAuditBox"
        @closePopup="closeAuditBoxPopup"
    />
  </div>
</template>

<script>
// import { CAPTCHA_ID } from "@/utils/config";
import {checkPhone, getEquipment} from "@/utils/index";
import AuditBox from "@/components/auditBox";

import {Form, Field, Button, Toast, Icon} from "vant";

import Bus from "@/Bus";
import l from "@/locales";
import {code, login} from "@/services/user";
import CodeInput from "@/views/login/components/codeInput";
import buriedPoint from "@/mixins/buriedPoint";

export default {
  name: "login",
  components: {AuditBox, Form, Field, Button, Icon, CodeInput},
  mixins: [buriedPoint],
  data() {
    return {
      loginMetdod: "code",
      activeName: "code",
      step: 0,
      l: {
        ...l.home,
        ...l.repayMethods,
        ...l.orderItem,
        ...l.other,
        ...l.tabbar,
        ...l.login,
      },
      deviceData: {
        w: null,
        h: null,
        system: null,
        latitude: null,
        longitude: null,
        hasOwnProperty: null,
        appCodeName: null,
        appName: null,
        appVersion: null,
        platform: null,
        userAgent: null,
        vendor: null,
      },
      textIndex: 0,
      isShowAuditBox: false,
      phone: null,
      code: null,
      isOver: false,
      time: 0,
    };
  },
  watch: {
    phone(val) {
      if (this.checkPhone(val)) {
        this.isOver = true;
      } else {
        this.isOver = false;
      }
    },
  },
  computed: {
    codeDesc() {
      let reg = /(\d{3})\d*(\d{3})/; // 定义手机号正则表达式
      if (this.phone) {
        let str = "<span style='color: #0090C2;'>" + this.phone.replace(reg, '$1****$2') + "</span>";
        return this.l.login_send_your_mobile_phone.replace("$1", str);
      }
      return "";
    }

  },
  methods: {
    checkPhone,
    checkCode(str) {
      return /^\d{6}$/.test(str);
    },
    getEquipment,
    inputComplete(str) {
      let params = {
        phone: this.phone,
        code: str,
      };
      this.handleCommit(params);
      console.log("inputComplete", str);
    },
    sendCode() {
      // this.captchaIns.refresh();
      // type 1 是登陆 2 是重置密码
      const params = {phone: this.phone, type: 2};
      code(params).then((res) => {
        if (res.code == 200) {
          this.step = 1;
          this.$saveAppsFlyer("发送短信", this.phone);
          this.time = 60;
          this.timer = setInterval(() => {
            if (this.time <= 1) {
              clearInterval(this.timer);
            }
            this.time--;
          }, 1000);
        }
      });
    },
    handleCommit(e) {
      if (!this.isOver) {
        return;
      }
      const {phone, code} = e;
      // public index.html 已经初始化
      // 提交点赞业务请求
      let regFrom;
      if (this.deviceData.system == "ios") {
        regFrom = 998;
      } else if (this.deviceData.system == "android") {
        regFrom = 999;
      } else if (this.deviceData.system == "other") {
        regFrom = 0;
      }

      const params = {
        // isRegister: "YES", // YES NO
        // ...this.deviceData,
        // lon: this.deviceData?.longitude,
        // lat: this.deviceData?.latitude,
        // screenResolution: this.deviceData?.screenResolution,
        // system: this.deviceData?.system,
        regFrom,
        // deviceToken: watchToken,
        phone,
        vcode: code,
      };
      login(params).then((res) => {
        if (res.code == 200) {
          if (!res.result.register) {
            this.$saveAppsFlyer("注册", phone);
          } else {
            this.$saveAppsFlyer("验证码登录", phone);
          }
          // 设置用户信息
          res.result.version = "1.0.0";
          this.$store.commit("SET_USER_INFO", res.result);
          // 清除LINE弹框标记，允许重新显示
          localStorage.removeItem('hasSeenLinePopup');
          // 三方埋点统计调用
          this.loginBuriedPoint(2, localStorage.getItem("channel"));
          // if (!res.result.lmbPassword) {
          //   // 没有密码跳转设置密码
          //   this.$router.replace("/setPass");
          //   return;
          // }
          // this.$router.replace("/home");
          // Toast.success({
          //   message: this.l.login_submit_success_toast,
          //   forbidClick: true,
          //   onClose: () => {
          if (sessionStorage.getItem("goback")) {
            this.$router.back(1);
          } else {
            this.$router.push("/home");
          }
          // },
          // });
        }
      });
      //     }
      // );
    },
    onFailed(err) {
      console.log(err);
    },
    loginMethodChange(str) {
      Toast("暂未开放", str);
    },
    closeAuditBoxPopup() {
      this.isShowAuditBox = false;
    },
    showAuditBox(index) {
      this.textIndex = index;
      this.isShowAuditBox = true;
    },
    changeMethod(data) {
      console.log("changeMethod data", data);
      let {type} = data;
      if (type == 0) {
        this.loginMetdod = "code";
      } else if (type == 1) {
        this.loginMetdod = "password";
      }
    },
    beforeDestroy() {
      if (sessionStorage.getItem("goback")) {
        sessionStorage.removeItem("goback");
      }
    },
    initNECaptchaCallback(type = 1) {
      if (type == 1) {
        this.$refs.code.sendCode();
      } else if (type == 2) {
        this.$refs.password.handleLogin();
      }
    },
  },
  created() {
    // this.phone = "954545459"
    // 初始化登陆类型
    let type = sessionStorage.getItem("loginType");
    if (type == 2) {
      // type为2时 验证码登录
      // 目前只有重置密码后跳转至此
      this.loginMetdod = "code";
      sessionStorage.removeItem("loginType");
    }
    // 初始化设备信息
    this.deviceData = this.getEquipment();
    console.log("登陆 getEquipment deviceData", this.deviceData);
  },
  mounted() {
    Bus.$emit("setUserInfo", {name: "123"});
  },
  beforeRouteEnter(to, from, next) {
    if (from.meta.goback) {
      sessionStorage.setItem("goback", "true");
    }
    next();
  },
};
</script>

<style lang="less" scope>
.loginSubmit {
  border: none;

  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;

  height: 48px;
  border-radius: 25px;
  background: #0090C2;
  opacity: 0.3;

}

.loginOver {
  opacity: 1;
}

.login_body {
  position: relative;
  height: 100%;
  min-height: 100vh;
  background: #F8FBFF;

  .login_header_img {
    width: 100%;
  }

  .login_header_img_bgi {
    width: 100%;
    height: 258px;
  }

  .productBox {
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);

    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }

    .productBox_hello {
      font-size: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #28435B;
      margin-top: 10px;
    }

    .productBox_welcome {
      margin-top: 5px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #949AA3;
    }

    .productBox_product {
      margin-top: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #28435B;
      text-align: center;
    }

  }

  .form_input_box {
    margin: 0 30px;
    padding-top: 258px;
    width: calc(100% - 60px);

    .field_label {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #28435B;
      margin-bottom: 4px;
    }

    .field-input {
      display: flex;
      align-items: center;
      padding: 0;

      height: 42px;
      background: transparent;
      border-bottom: 1px solid #C9D2DC;

      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #0090C2;

      .van-field__control {
        color: #0090C2 !important;
      }

      /deep/ .van-field__value {
        position: relative;
      }

      /deep/ .van-field__error-message {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
      }

      .leftBox {
        display: flex;

        border-right: 2px solid rgba(69, 161, 255, 0.3);
        margin-right: 10px;

        .leftIconImg {
          margin-left: 20px;
          margin-right: 10px;
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .form_box {
    margin: 0 42px;
    // background: #ffffff;
    // box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    // border-radius: 19px;
    overflow: hidden;
  }

  .van-field__error-message {
    display: none;
  }

  .commit_checkbox {
    margin-top: 20px;
    text-align: center;

    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #949AA3;

    .privacy {
      margin-left: 4px;
      color: #777777;
    }
  }

  .code_text {
    margin-top: 60px;
    margin-left: 30px;

    .code_text_title {
      font-size: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #28435B;
    }

    .code_text_desc {
      margin-top: 5px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #949AA3;
    }
  }

  .CodeInput_box {
    margin-top: 60px;
    padding: 0 30px;
  }

  .code_time_box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 0 30px;
    margin-top: 20px;

    .code_time {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #949AA3;
    }

    span {
      color: #0090C2;
    }
  }

  .code_again_box {
    margin: 0 50px;
    margin-top: 40px;
  }
}
</style>
